// extracted by mini-css-extract-plugin
export default {"link":"Home_link__7E0HK","main":"Home_main__M0RkF","title":"Home_title__MlBk8"};